import { useState, useEffect } from 'react';

export function isMediaQuery(minWidth) {
  return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
}

export function is375Query() {
  return isMediaQuery(375);
}

export function is640Query() {
  return isMediaQuery(640);
}

export function is768Query() {
  return isMediaQuery(768);
}

export function is769Query() {
  return isMediaQuery(769);
}

export function is960Query() {
  return isMediaQuery(960);
}

export function is1200Query() {
  return isMediaQuery(1200);
}

export function is1600Query() {
  return isMediaQuery(1600);
}

export function is1800Query() {
  return isMediaQuery(1800);
}

export function is2000Query() {
  return isMediaQuery(2000);
}

export const isSmallScreen = !is768Query();

export function useMediaQuery(matchMedia) {
  const [result, setResult] = useState(false);
  const mediaQuery =
    typeof window === 'undefined' ? mockMediaQueryList : window.matchMedia(matchMedia);

  useEffect(() => {
    let mounted = true;

    const onChange = () => {
      if (!mounted) {
        return;
      }
      setResult(mediaQuery.matches);
    };

    try {
      // Chrome & Firefox
      mediaQuery.addEventListener('change', onChange);
      setResult(mediaQuery.matches);

      return () => {
        mounted = false;
        mediaQuery.removeEventListener('change', onChange);
      };
    } catch (e1) {
      try {
        // Safari
        mediaQuery.addListener(onChange);
        setResult(mediaQuery.matches);

        return () => {
          mounted = false;
          mediaQuery.removeListener(onChange);
        };
      } catch (e2) {
        console.error(e2);
      }
    }
  }, []);

  return result;
}
